import styled from 'styled-components';

import {
  xdlColorTextOnLight,
  scale100,
  scale090,
  scale110,
  scale130,
  scale150,
  scale280,
} from '@xingternal/tokens';

import { Headline } from '@xingternal/typography';

import { mediaConfined } from '@xingternal/layout-tokens';
import { sectionInnerContainerMixin, sectionMixin } from '../variables.style';

export const Text = styled(Headline)`
  margin-top: ${scale090};
  max-width: ${scale280};
`;

export const Feature = styled.a`
  color: ${xdlColorTextOnLight};
  text-decoration: none !important;
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  width: 40%;
  flex: 1 0 auto;
  margin-top: ${scale110};
  margin-bottom: ${scale110};
  &:nth-child(odd) {
    margin-right: ${scale100};
  }

  @media ${mediaConfined} {
    flex-shrink: 1;
  }
`;

export const Container = styled.div`
  ${sectionMixin};
  ${sectionInnerContainerMixin};
  text-align: center;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;

  @media ${mediaConfined} {
    flex-wrap: nowrap;
  }
`;

export const IconContainer = styled.div`
  width: ${scale130};

  @media ${mediaConfined} {
    width: ${scale150};
  }
`;
